(function () {
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initMobileNav() {
    var toggles = document.querySelectorAll("[data-oj-menu-toggle]");
    toggles.forEach(function (toggle) {
      var targetId = toggle.getAttribute("aria-controls");
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      toggle.addEventListener("click", function () {
        var isOpen = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isOpen));
        target.classList.toggle("is-open", !isOpen);
      });
    });
  }

  function initBackToTop() {
    var button = document.querySelector("[data-oj-back-to-top]");
    if (!button) return;

    function updateVisibility() {
      var visible = window.scrollY > 600;
      button.classList.toggle("is-visible", visible);
      button.setAttribute("aria-hidden", String(!visible));
      button.tabIndex = visible ? 0 : -1;
    }

    button.addEventListener("click", function () {
      window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? "auto" : "smooth" });
    });

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initBackToTop();
    document.documentElement.classList.remove("no-js");
    document.documentElement.classList.add("js");
  });
})();